import { useCustomGetWorksheetProductQuery } from "generated/graphql";

export default function useGetWorksheetProduct(id?: string) {
  const { loading, data, error, refetch } = useCustomGetWorksheetProductQuery({
    variables: { id: id ?? "" },
    skip: !id,
  });

  return {
    loading,
    error,
    data: data?.getWorksheetProduct ?? null,
    refetch,
  } as const;
}
